import styled from '@emotion/styled';
import { CodeBlock, Link, Text, tokens } from '@hotjar/hotsauce';
import FoundingMemberImage from '@hotjar/shared-assets/images/founding-member.png';
import { Trans, useTranslation } from '@hotjar/translations';

const MediaContainer = styled.div`
  ${tokens.flexContainer()};
  margin-top: ${tokens.spacer.x3};
  align-items: start;
`;

export function FoundingMemberBadge(): JSX.Element {
  const { t } = useTranslation('common');

  const codeString = `<a href="https://www.hotjar.com/founding-members?utm_source=badge" target="_blank">
  <img src="https://insights.hotjar.com/b/founding-member.png" alt="${t(
    'settings-account.founding-member.badge-alt-text',
  )}" />
</a>`;

  const foundingMembersUrl = 'https://www.hotjar.com/founding-members';

  return (
    <div>
      <Text as="h5" textType="header5">
        {t('settings-account.founding-member.title')}
      </Text>

      <Text as="p" textType="body2">
        {t('settings-account.founding-member.description-1')}
      </Text>
      <Text as="p" textType="body2">
        <Trans
          t={t}
          i18nKey="settings-account.founding-member.description-2"
          components={[
            <Link href={foundingMembersUrl} kind="inline" isExternal>
              Founding Members
            </Link>,
          ]}
        />
      </Text>

      <MediaContainer>
        <a href={foundingMembersUrl} target="_blank" rel="noreferrer">
          <img
            src={FoundingMemberImage}
            alt={t('settings-account.founding-member.badge-alt-text')}
          />
        </a>

        <CodeBlock content={codeString} allowCopy />
      </MediaContainer>
    </div>
  );
}
